import React, {useEffect, useState} from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import {useGetRequest} from '../../../hooks/useGetRequest/useGetRequest';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';

import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from '../../../helper/utils';
import {
    getAllCargosAPI,
    getAllEstadosAPI,
    getAllSedesAPI,
    getListaMisDocumentosAPI, getAllAreasAPI,
    getMainFiltrosListarMisDocumentosAPI
} from "../../../consumers/backendApisUrls";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import Select from "react-select";
import styled from "styled-components";
import ModalEnabled from "../../../components/modalComponents/ModalEnabled";
import MisTableFlujoDocumentoEmpleado from "./MisTableFlujoDocumentoEmpleado";

const INIT_KEYS = {
    IdsSedes: "IdsSedes",
    IdsAreas: "IdsAreas",
    IdsCargos: "IdsCargos",
    IdsEstados: "IdsEstados",
};

const MisFlujoDocumentoEmpleados = () => {
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [allFilters, setAllFilters] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);

    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const [MainFiltrosItems, setMainFiltrosItems] = useState([]);
    const [selectedMainFiltro, setSelectedMainFiltro] = useState({});

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllSedesAPI()),
            executeGet(getAllAreasAPI()),
            executeGet(getAllCargosAPI()),
            response
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await getFiltrosGenerales();
            await manageSearch();
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaMisDocumentosAPI();

        if (selectedMainFiltro?.value){
            const payload = getPayload();
            await executeManagePost(api, payload, successManageSearchCallback);
        }

        setIsLoading(false);
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            MainFiltroListarMisDocumentosId: selectedMainFiltro?.value,
            ...formValues.selectedFilters
        }
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
        setIsLoading(false);
    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    const getFiltrosGenerales = async () => {
        const api = getMainFiltrosListarMisDocumentosAPI();
        await executeManageGet(api, (res) => sucessInitCallback(res), false);
    }

    const sucessInitCallback = ({data}) => {
        const items = data.map(o => ({value: o.Value, label: o.Text}));
        console.log("data ", items)
        setMainFiltrosItems(items);
        if (items.length > 0)
            setSelectedMainFiltro(items[0])
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters, selectedMainFiltro?.value])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();

    }, [])


    return (
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Mis Documentos"/>
            <SelectMainFiltros items={MainFiltrosItems} selectedItem={selectedMainFiltro}
                               setSelectedItem={setSelectedMainFiltro}/>
            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>

                </ButtonsWrapper>
            </SearchContainer>

            <MisTableFlujoDocumentoEmpleado
                formValues={formValues}
                setFormValues={setFormValues}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                fromAdminPage={false}
                manageSearch={manageSearch}
            />
        </PageWrapper>
    );
}

export default MisFlujoDocumentoEmpleados;

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;

const SelectMainFiltros = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
        <Select
            options={items}
            value={selectedItem}
            onChange={(res) => setSelectedItem({...res})}
            placeholder="Seleccionar "
        />
    </div>
)
